import {Textarea, TextareaProps} from '@chakra-ui/react';
import React, {memo} from 'react';

interface Props extends TextareaProps {}

export const UiTextarea = memo(function UiTextarea({...rest}: Props) {
  return <Textarea _focus={{borderColor: 'orange.500'}} {...rest} />;
});
